import { useState } from "react";
import WorkScheduleTable from "../../../shared/work-schedule/WorkScheduleTable";

export default function WorkSchedule() {
  return <WorkScheduleTable title="Графік команди" />;
}
